<div id="period-totals">

  <div class="item" *ngIf="isAdmin">
    <div class="headerText">Active Venues</div>
    <div class="contentText" *ngIf="!isLoading">
      {{ activeVenues }}
    </div>
    <div class="contentText" *ngIf="isLoading">
      <div class="d-flex justify-content-center align-items-center">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="item">
    <div class="headerText">Revenue</div>
    <div class="contentText" *ngIf="!isLoading">
      {{ mask(revenue) }}
    </div>
  </div>
  <div class="item">
    <div class="headerText">Units Sold</div>
    <div class="contentText" *ngIf="!isLoading">{{ unitsSold }}</div>
  </div>
  <div class="item">
    <div class="headerText">New Accounts</div>
    <div class="contentText" *ngIf="!isLoading">{{ newCustomers }}</div>
  </div>
  <div class="item">
    <div class="headerText">Unique Customers</div>
    <p class="contentText" *ngIf="!isLoading">
      {{ uniqueCustomers }}
    </p>
  </div>
</div>
